import * as React from "react";

import { t } from "@impero-com/common/utils/i18n";
import { Divider, InfoTooltip } from "@impero-com/ui";

import { SubsequentStepIndex } from "api/generated/model";

abstract class BaseManualRecurrenceRuleUpdaterForm<
    P,
> extends React.PureComponent<P> {
    render = () => {
        return (
            <>
                <Divider />
                {this.buildDueDateAndTimeInputs()}
                <Divider />
                <h1>
                    {t("CreateControl_Planning_Title")}&nbsp;
                    <InfoTooltip
                        text={t("Control_ModifySchedule_PlanningInfo")}
                    />
                </h1>
                {this.buildResponsibleAllocatedTimeInputs()}
                {this.buildReviewerAllocatedTimeInputs("SubsequentStep0")}
                {this.buildReviewerAllocatedTimeInputs("SubsequentStep1")}
                <Divider />
                {this.buildRemindersWidget()}
            </>
        );
    };

    abstract buildDueDateAndTimeInputs(): React.ReactNode;

    abstract buildResponsibleAllocatedTimeInputs(): React.ReactNode;

    abstract buildReviewerAllocatedTimeInputs(
        subsequentStepIndex: SubsequentStepIndex
    ): React.ReactNode;

    abstract buildRemindersWidget(): React.ReactNode;
}

interface BaseManualRecurrenceRuleProps {
    buildDueDateAndTimeInputs: (
        readOnly: "EDIT" | "READ_ONLY"
    ) => React.ReactNode;
    buildResponsibleAllocatedTimeInputs: (
        readOnly: "EDIT" | "READ_ONLY"
    ) => React.ReactNode;
    buildReviewerAllocatedTimeInputs: (
        readOnly: "EDIT" | "READ_ONLY",
        subsequentStepIndex: SubsequentStepIndex
    ) => React.ReactNode;
    buildRemindersWidget: (readOnly: "EDIT" | "READ_ONLY") => React.ReactNode;
}

interface ManualRecurrenceRuleUpdaterProps {
    buildDueDateAndTimeInputs: (
        readOnly: "EDIT" | "READ_ONLY"
    ) => React.ReactNode;
    buildResponsibleAllocatedTimeInputs: (readOnly: "EDIT") => React.ReactNode;
    buildReviewerAllocatedTimeInputs: (
        readOnly: "EDIT",
        subsequentStepIndex: SubsequentStepIndex
    ) => React.ReactNode;
    buildRemindersWidget: (readOnly: "EDIT") => React.ReactNode;
}

class ManualRecurrenceRuleUpdater extends BaseManualRecurrenceRuleUpdaterForm<ManualRecurrenceRuleUpdaterProps> {
    buildDueDateAndTimeInputs = () =>
        this.props.buildDueDateAndTimeInputs("EDIT");
    buildResponsibleAllocatedTimeInputs = () =>
        this.props.buildResponsibleAllocatedTimeInputs("EDIT");
    buildReviewerAllocatedTimeInputs = (
        subsequentStepIndex: SubsequentStepIndex
    ) =>
        this.props.buildReviewerAllocatedTimeInputs(
            "EDIT",
            subsequentStepIndex
        );
    buildRemindersWidget = () => this.props.buildRemindersWidget("EDIT");
}

class ManualRecurrenceRuleViewer extends BaseManualRecurrenceRuleUpdaterForm<ManualRecurrenceRuleViewerProps> {
    buildDueDateAndTimeInputs = () =>
        this.props.buildDueDateAndTimeInputs("READ_ONLY");
    buildResponsibleAllocatedTimeInputs = () =>
        this.props.buildResponsibleAllocatedTimeInputs("READ_ONLY");
    buildReviewerAllocatedTimeInputs = (
        subsequentStepIndex: SubsequentStepIndex
    ) =>
        this.props.buildReviewerAllocatedTimeInputs(
            "READ_ONLY",
            subsequentStepIndex
        );
    buildRemindersWidget = () => this.props.buildRemindersWidget("READ_ONLY");
}

type ManualRecurrenceRuleViewerProps = BaseManualRecurrenceRuleProps;

export { ManualRecurrenceRuleUpdater, ManualRecurrenceRuleViewer };
